import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import App from './maps-app';

const MOUNT_NODE = document.createElement('div'); // dummy

function defaultImageFileFunction(dataset, variable, prefecture, model, rcp, period) {
  const { variable2CategoryMap } = window;

  const category = variable2CategoryMap[variable];
  return `imgs/maps/${prefecture}/${dataset}/${category}/${variable}/${prefecture}_${variable}_${model}_${rcp}_${period}.png`;
}
window.defaultImageFileFunction = defaultImageFileFunction;

const render = () => {
  const { dataset, variable, rcpLeft, rcpRight, initialPrefecture, initialModel, initialPeriod, prefectureMap, modelMap, periodMap, imageFileFunction, single } = window;

  ReactDOM.render(
    <App
      dataset={dataset}
      variable={variable}
      rcpLeft={rcpLeft}
      rcpRight={rcpRight}
      initialPrefecture={initialPrefecture}
      initialModel={initialModel}
      initialPeriod={initialPeriod}
      prefectureMap={prefectureMap}
      modelMap={modelMap}
      periodMap={periodMap}
      imageFileFunction={imageFileFunction != null ? imageFileFunction : defaultImageFileFunction}
      single={single}
    />, MOUNT_NODE);
};

render();
